// extracted by mini-css-extract-plugin
module.exports = {"confirmModalWidget":"ModalWidget_confirmModalWidget__3kZ8N","modalWidget":"ModalWidget_modalWidget__2JU5n"};